<template>
  <div class="">
    <edit-company> </edit-company>
  </div>
</template>

<script>
import EditCompany from "@/components/profile/companies-products/insurers/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    EditCompany,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Compagnie",
        path: "module.PROF",
        tab: "#Companies",
        level: 3,
      });
      bcs.push({ text: "Modifica Compagnia", path: "insurers.edit", level: 4 });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Compagnie",
        path: "module.PROF",
        tab: "#Companies",
        level: 3,
      });
      this.notifyQueue({
        text: "Modifica Compagnia",
        path: "insurers.edit",
        level: 4,
      });
    }
  },
};
</script>
